import { SkeletonLoader } from "@pepperstone/pepper-ui-kit";
import clsx from "clsx";
import styles from "./SelectableCardSkeleton.module.css";

type SelectableCardSkeletonProps = {
  showRadio?: boolean;
  className?: string;
};

export const SelectableCardSkeleton = ({
  showRadio = true,
  className,
}: SelectableCardSkeletonProps) => (
  <div className={clsx(styles.card, className)}>
    {showRadio && <SkeletonLoader variant="circular" height={5} width={5} />}
    <SkeletonLoader variant="circular" height={10} width={10} />
    <div className={styles.texts}>
      <SkeletonLoader
        variant="rectangular"
        rounding="sm"
        extraClasses={styles["text-primary"]}
      />
      <SkeletonLoader
        variant="rectangular"
        rounding="sm"
        extraClasses={styles["text-secondary"]}
      />
    </div>
  </div>
);
